import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SkypeFilledSvg from "@ant-design/icons-svg/es/asn/SkypeFilled";
import AntdIcon from "../components/AntdIcon";
var SkypeFilled = function SkypeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SkypeFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SkypeFilled.displayName = 'SkypeFilled';
}
export default /*#__PURE__*/React.forwardRef(SkypeFilled);